<script setup lang="ts">
import { useAgreementStore } from '@/stores/agreement';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import { formatCurrency } from '@/helpers';
import AgreementSummaryComponent from './AgreementSummaryComponent.vue';

const { basePrice, addonsPrice, calculating, isOkay } = storeToRefs(useAgreementStore())
// const agreementStore = useAgreementStore()
const monthlyPrice = computed(() => basePrice.value + addonsPrice.value)
</script>

<template>
  <div>
    <v-overlay transition="slide-y-transition" location-strategy="connected">
      <template #activator="{ props }">
        <v-sheet
          v-bind="props"
          color="primary"
          class="px-2 py-1 d-flex align-center cursor-pointer"
          rounded
          style="min-width: 110px;"
        >
          <v-icon size="small" class="mr-auto">
            mdi-cart-outline
          </v-icon>
          <div class="d-flex flex-column flex-grow-1 align-end">
            <div class="d-flex align-center justify-end w-100" style="height: 20px;">
              <v-progress-linear v-if="calculating" height="8" indeterminate rounded rounded-bar style="width: 80%;" />
              <span v-else class="font-weight-bold" style="font-size: 14px;">{{ isOkay ? formatCurrency(monthlyPrice) : "error" }}</span>
            </div>
            <span style="font-size: 10px;" v-if="isOkay">pr. måned</span>
          </div>
        </v-sheet>
      </template>
      <AgreementSummaryComponent v-if="isOkay" v-show="isOkay" />
    </v-overlay>
  </div>
</template>